import React, { useState, useEffect } from "react";
import { Typography, Button, Modal } from "antd";
import { Badge } from "antd";
import { Calendar } from "../../../../components/antOverrides";
import moment from "moment";
import { useDispatch } from "react-redux";
import FormHeaderWrapper from "../../../../components/forms/FormHeader.style";
import NewHolidayDay from "./NewHolidayDay";
import HolidaysTable from "./HolidaysTable";
import { FormattedMessage } from "react-intl";
import { listHolidays } from "../../../../api/server";
import { useReligions } from "../../../../hooks";
import { deleteTableItem } from "../../../settings/settingsSlice";
import Header from "./Header";
import RestrictedComponent from "../../../../components/util/RestrictedComponent";

const { Title } = Typography;

const Holidays = (props) => {
  const [items, setItems] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [relgionId, setRelgionId] = useState(1);
  const [newHolidayVisible, setNewHolidayVisible] = useState(false);
  const [currentDate, setCurrentDate] = useState(moment().format());
  const [viewStyle, setViewStyle] = useState("table");
  const dispatch = useDispatch();
  const religions = useReligions();
  useEffect(() => {
    getData();
  }, [relgionId, currentDate]);

  const getData = () => {
    let filter = {
      $and: [
        { religion_id: relgionId },
        {
          date: {
            $gt: moment(currentDate).startOf("year"),
            $lt: moment(currentDate).endOf("year"),
          },
        },
      ],
    };

    listHolidays({ filter }).then(({ error, data }) => {
      if (data) {
        setItems(data.items);
      }
    });
  };

  const dateCellRender = (value) => {
    const listData = items.filter((h) => moment(h.date).isSame(value, "day"));

    return (
      <ul style={{ padding: 0 }}>
        {listData.map((item) => (
          <Badge key={item.id} status={"success"} text={item.name} />
        ))}
      </ul>
    );
  };

  const onSelect = (val) => {
    setRelgionId(val);
  };

  const onAddClick = () => {
    setNewHolidayVisible(true);
  };

  const onEditClick = (item) => {
    setActiveItem(item);
    setNewHolidayVisible(true);
  };

  const hide = () => {
    setActiveItem(null);
    setNewHolidayVisible(false);
  };

  const onDelete = async (item) => {
    const params = {
      source: "salary/holidays",
      record: item,
    };

    const action = await dispatch(deleteTableItem(params));
    if (!action.error) {
      hide();
      getData();
    }
  };
  const onChangeView = (e) => {
    setViewStyle(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        paddingBottom: "10px",
        flexDirection: "column",
      }}
    >
      <FormHeaderWrapper>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Title level={5} style={{ margin: 0 }}>
            <FormattedMessage id={`app.settings.holidays`} />
          </Title>
          <RestrictedComponent
            resource={"organization.settings"}
            action={"editor"}
            comp={null}
          >
            <Button type="primary" onClick={onAddClick}>
              <FormattedMessage id="app.forms.holiday.addNewHolidayDay" />
            </Button>
          </RestrictedComponent>
        </div>
      </FormHeaderWrapper>
      <div>
        {viewStyle === "table" ? (
          <div>
            <Header
              religions={religions}
              viewStyle={viewStyle}
              currentDate={currentDate}
              onSelect={onSelect}
              relgionId={relgionId}
              setCurrentDate={setCurrentDate}
              onChangeView={onChangeView}
            />
            <HolidaysTable
              items={items}
              onDelete={onDelete}
              onEditClick={onEditClick}
            />
          </div>
        ) : (
          <Calendar
            dateCellRender={dateCellRender}
            headerRender={({ value, type, onChange, onTypeChange }) => {
              return (
                <Header
                  religions={religions}
                  viewStyle={viewStyle}
                  currentDate={currentDate}
                  onSelect={onSelect}
                  relgionId={relgionId}
                  setCurrentDate={setCurrentDate}
                  onChangeView={onChangeView}
                  onChange={onChange}
                  value={value}
                />
              );
            }}
          />
        )}
      </div>
      <Modal
        closable={false}
        maskClosable={false}
        open={newHolidayVisible}
        footer={null}
        onCancel={hide}
        title={null}
        width={"fit-content"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        destroyOnClose={true}
      >
        {newHolidayVisible ? (
          <NewHolidayDay
            record={activeItem}
            getData={getData}
            hide={hide}
            addText={
              activeItem ? (
                <FormattedMessage id="app.forms.holiday.editNewHolidayDay" />
              ) : (
                <FormattedMessage id="app.forms.holiday.addNewHolidayDay" />
              )
            }
          />
        ) : null}
      </Modal>
    </div>
  );
};

export default Holidays;
